module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page bg-gray pb-fixed-btn"
  }, [_c('backTitleBar'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "pd-020"
  }, [_c('div', {
    staticClass: "input-field bd-bot"
  }, [_vm._m(0), _vm._v(" "), _c('van-field', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "clearable": true,
      "placeholder": "请输入营业执照单位名称"
    },
    on: {
      "click": function($event) {
        return _vm.inputClick()
      }
    },
    model: {
      value: (_vm.formItem.licenseName),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "licenseName", $$v)
      },
      expression: "formItem.licenseName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-field bd-bot"
  }, [_c('div', {
    staticClass: "fs-32 color-333 left required"
  }, [_vm._v("营业执照号")]), _vm._v(" "), _c('van-field', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "clearable": true,
      "placeholder": "请输入营业执照号"
    },
    on: {
      "click": function($event) {
        return _vm.inputClick()
      }
    },
    model: {
      value: (_vm.formItem.licenseNo),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "licenseNo", $$v)
      },
      expression: "formItem.licenseNo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-field bd-bot"
  }, [_c('div', {
    staticClass: "fs-32 color-333 left required"
  }, [_vm._v("法人姓名")]), _vm._v(" "), _c('van-field', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "clearable": true,
      "placeholder": "请输入法人姓名"
    },
    on: {
      "click": function($event) {
        return _vm.inputClick()
      }
    },
    model: {
      value: (_vm.formItem.identityName),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "identityName", $$v)
      },
      expression: "formItem.identityName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-field bd-bot"
  }, [_vm._m(1), _vm._v(" "), _c('van-field', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "clearable": true,
      "placeholder": "请输入法人身份证号"
    },
    on: {
      "click": function($event) {
        return _vm.inputClick()
      }
    },
    model: {
      value: (_vm.formItem.identityCard),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "identityCard", $$v)
      },
      expression: "formItem.identityCard"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-field bd-bot"
  }, [_c('div', {
    staticClass: "fs-32 color-333 left required"
  }, [_vm._v("注册地址")]), _vm._v(" "), _c('van-field', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "clearable": true,
      "placeholder": "请输入注册地址"
    },
    on: {
      "click": function($event) {
        return _vm.inputClick()
      }
    },
    model: {
      value: (_vm.formItem.regAddress),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "regAddress", $$v)
      },
      expression: "formItem.regAddress"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "filed-input-box bd-bot"
  }, [_c('div', {
    staticClass: "required fs-32 color-333"
  }, [_vm._v("上传清晰营业执照")]), _vm._v(" "), _c('div', {
    staticClass: "fs-28 color-999 pl-15"
  }, [_vm._v("(支持jpg、bmp格式图片，大小不要超过1M/张)")]), _vm._v(" "), _c('div', {
    staticClass: "flex",
    staticStyle: {
      "flex-wrap": "wrap"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formItem.licensePicView),
      expression: "formItem.licensePicView"
    }],
    staticClass: "pic-box"
  }, [_c('img', {
    attrs: {
      "src": _vm.formItem.licensePicView,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clean",
    on: {
      "click": function($event) {
        return _vm.delImg('licensePicView')
      }
    }
  })]), _vm._v(" "), _c('van-uploader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.formItem.licensePicView),
      expression: "!formItem.licensePicView"
    }],
    attrs: {
      "preview-size": "1.45rem",
      "preview-image": false,
      "after-read": _vm.afterReadLicense
    },
    model: {
      value: (_vm.imgList),
      callback: function($$v) {
        _vm.imgList = $$v
      },
      expression: "imgList"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "filed-input-box bd-bot"
  }, [_c('div', {
    staticClass: " fs-32 color-333"
  }, [_vm._v("上传其他清晰证件")]), _vm._v(" "), _c('div', {
    staticClass: "fs-28 color-999 pl-15"
  }, [_vm._v("(支持jpg、bmp格式图片，大小不要超过1M/张)")]), _vm._v(" "), _c('div', {
    staticClass: "flex",
    staticStyle: {
      "flex-wrap": "wrap"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formItem.otherPicView),
      expression: "formItem.otherPicView"
    }],
    staticClass: "pic-box"
  }, [_c('img', {
    attrs: {
      "src": _vm.formItem.otherPicView,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clean",
    on: {
      "click": function($event) {
        return _vm.delImg('otherPicView')
      }
    }
  })]), _vm._v(" "), _c('van-uploader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.formItem.otherPicView),
      expression: "!formItem.otherPicView"
    }],
    attrs: {
      "preview-size": "1.45rem",
      "preview-image": false,
      "after-read": _vm.afterReadOther
    },
    model: {
      value: (_vm.imgList),
      callback: function($$v) {
        _vm.imgList = $$v
      },
      expression: "imgList"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "fixed-bot"
  }, [_c('div', {
    staticClass: "btn click",
    on: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  }, [_vm._v("保存")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fs-32 color-333 left required"
  }, [_vm._v("营业执照"), _c('br'), _vm._v("单位名称")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fs-32 color-333 left required"
  }, [_vm._v("法人"), _c('br'), _vm._v("身份证号")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57274174","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/shop/shopSetting/qualifyInfo.vue
// module id = M7f5
// module chunks = 51